/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import { cartCheckoutReducers } from 'ui-cart';

import parkpassReducers from '../src/reducers';
import moduleStore from '../src/store';

const initialState = {
    ...moduleStore(),
};

const rootReducer = combineReducers({
    /**
     * Originally this key was `cart`. I switched to `checkout` for two reasons:
     * 1) sarsaparillaReducers was overriding it
     * 2) cartCheckoutReducers is used in `ui-cart/dev/store.ts` and uses as key
     *    `checkout`
     */
    checkout: cartCheckoutReducers,
    parkpass: parkpassReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

export function setupStore(preloadedState?: any) {
    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly'],
                },
                immutableCheck: {
                    ignoredPaths: ['parkpass'],
                },
            });
        },
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    return store;
}

const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

export default store;

// cSpell:ignore parkpass
